import { SocialProvider, useSocialConnect } from "@/auth"
import { GoogleIcon } from "@/ui/components/icons"
import IconButton from "@/ui/composed/IconButton"
import { $enum } from "@/utils"

const ICONS = {
  [SocialProvider.Google]: <GoogleIcon />,
}

export default function SocialLogin() {
  const { handleConnect, isConnecting } = useSocialConnect()

  const handleConnectPress = (provider: SocialProvider) => () => {
    handleConnect(provider)
  }

  return (
    <div className="flex flex-row justify-center gap-2">
      {$enum(SocialProvider).map((provider, label) => (
        <IconButton
          key={provider}
          icon={ICONS[provider]}
          onClick={handleConnectPress(provider)}
          disabled={isConnecting}
          title={`Continue with ${label}`}
        />
      ))}
    </div>
  )
}
